const NAME = "GEOANALYSIS";

export default NAME;
